module.exports = __webpack_public_path__ + "img/centerlogo.fde14e61.png";